// Legacy fallback data - data is now primarily loaded from API
// This file provides empty defaults when API is unavailable

export const projects = [];
export const artists = [];
export const companies = [];
export const updates = [];

export const getProjectBySlug = (slug) => null;
export const getFrameworkBySlug = (slug) => null;
export const getUniverseBySlug = (slug) => null;
